import { css, cx } from "@emotion/css"
import { Box } from "@material-ui/core"
import { Loading } from "components/Loading"
import { FooterColumn } from "../../types"

const styles = {
  footer: css`
    display: flex;
  `,
  info: css`
    color: var(--white);
    width: 100%;
    text-align: right;
    position: relative;
    font-size: 12px;
    padding-right: 24px;
  `,
  cell: ({ gap }: { gap: number }) => css`
    padding-right: ${gap}px;
  `,
  coloredGreen: css`
    color: var(--primary-main-light-green);
  `,
  coloredRed: css`
    color: var(--red);
  `,
}

type TableProps = {
  isLoading?: boolean
  footer: FooterColumn[]
  columnWidth: number
  gap: number
  columnsLength: number
}

export function FooterTable(props: TableProps) {
  const { footer, isLoading, columnWidth, gap, columnsLength } = props

  const getClassName = (cell: FooterColumn) => {
    const shouldBeRed = cell.numeric! < 0 && cell.isColored
    const shouldBeGreen = cell.numeric! > 0 && cell.isColored

    return { shouldBeGreen, shouldBeRed }
  }

  const cellWidth = columnWidth / columnsLength

  return (
    <>
      {!isLoading ? (
        <div className={styles.footer}>
          {footer.map((cell, index) => {
            return (
              <Box
                key={index}
                width={cell.customWidth ?? cellWidth}
                display="flex"
              >
                <div
                  className={cx(
                    styles.info,
                    styles.cell({ gap: gap }),
                    css`
                      height: 30px;
                      display: flex;
                      justify-content: ${cell.align ?? "right"};
                      align-items: center;
                      ${cell.customStyles}
                    `,
                    {
                      [styles.coloredRed]: getClassName(cell).shouldBeRed,
                      [styles.coloredGreen]: getClassName(cell).shouldBeGreen,
                    },
                  )}
                  key={index}
                >
                  {cell.value}
                </div>
              </Box>
            )
          })}
        </div>
      ) : (
        <Loading />
      )}
    </>
  )
}
